import { render, staticRenderFns } from "./NoFotoWoman.vue?vue&type=template&id=f9c4e7be&scoped=true&"
import script from "./NoFotoWoman.vue?vue&type=script&lang=ts&"
export * from "./NoFotoWoman.vue?vue&type=script&lang=ts&"
import style0 from "./NoFotoWoman.vue?vue&type=style&index=0&id=f9c4e7be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9c4e7be",
  null
  
)

export default component.exports